import Col from "../../../components/element/col";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/element/icon";
import Row from "../../../components/element/row";

const trustList = [
  {
    icon: "streamline-ultimate:car-3-bold",
    title: "DCAR Certified",
    description: "160 Point Inspection",
  },
  {
    icon: "tdesign:secured",
    title: "No Hidden Fees",
    description: "Sell With Peace Of Mind",
  },
  {
    icon: "lucide:handshake",
    title: "Direct Owner",
    description: "Buyer Confidence",
  },
];

export default function HomeHero() {
  const { t } = useTranslation();
  return (
    <Col className="_col home-hero">
      <h1 className="_label home-title">
        <span>{t("CONSIGNMENT")}</span>
        <span>{t("DIRECT OWNER")}</span>
      </h1>
      <Col className="_col trust-list">
        {trustList.map((item, index) => (
          <Row className="_row trust-item" key={item.title}>
            <Icon
              tag="span"
              icon={item.icon}
              className="_svg trust"
              gradient
              width={18}
              height={18}
            />
            <Col className="_col trust-copy">
              <p className="_label trust-title">{t(item.title)}</p>
              <p className="_label trust-description">{t(item.description)}</p>
            </Col>
          </Row>
        ))}
      </Col>
    </Col>
  );
}
